import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/app/see-you-on-a-call/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/runner/work/udata-site/udata-site/components/UI/Button/Button.tsx");
